/**
 * @file Context/WishlistContext.jsx
 * @description Wishlist context provider. Manages a list of favorited tours
 * with add, remove, and check functions available to all child components.
 */

import React, { createContext, useState } from 'react';

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState([]);

  const addToWishlist = (tour) => {
    setWishlist((prev) => {
      const exists = prev.some((item) => item.title === tour.title);
      return exists ? prev : [...prev, tour];
    });
  };

  const removeFromWishlist = (title) => {
    setWishlist((prev) => prev.filter((item) => item.title !== title));
  };

  const isInWishlist = (title) => wishlist.some((item) => item.title === title);

  return (
    <WishlistContext.Provider value={{ wishlist, addToWishlist, removeFromWishlist, isInWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};
